package com.veldekar.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.widgets.LocalizedSessionDate
import kotlinx.datetime.LocalDate

/**
 * A specialized layout for session log pages that wraps [PageLayout] and [LogPageContent].
 * This reduces boilerplate in generated session files.
 */
@Composable
fun SessionPageLayout(
    ctx: PageContext,
    title: String,
    ogTitle: String? = null,
    date: LocalDate? = null,
    ogDescription: String? = null,
    ogImage: String? = null,
    ogImageWidth: Int? = null,
    ogImageHeight: Int? = null,
    ogImageAlt: String? = null,
    aiHint: String? = null,
    content: @Composable () -> Unit
) {
    val data = PageLayoutData(
        title = title,
        date = date,
        ogTitle = ogTitle ?: title,
        ogDescription = ogDescription,
        ogImage = ogImage,
        ogImageWidth = ogImageWidth,
        ogImageHeight = ogImageHeight,
        ogImageAlt = ogImageAlt,
        aiHint = aiHint
    )

    PageLayout(ctx, data) {
        LogPageContent {
            if (date != null) {
                LocalizedSessionDate(date)
            }
            content()
        }
    }
}
